/**
 * Marca as fotos de avatar como carregadas ou com erro, para o CSS global
 * (global.scss) mostrar o skeleton enquanto a imagem baixa e fazer o fade-in ao terminar.
 *
 * Eventos de imagem não sobem na árvore, por isso usamos captura no document.
 */
const AVATAR_CONTAINER_SELECTOR = 'ion-avatar, .avatar-skeleton';

export function initAvatarImageLoading(): void {
  document.addEventListener('load', (event) => markAvatarImage(event, 'is-loaded'), true);
  document.addEventListener('error', (event) => markAvatarImage(event, 'is-failed'), true);
}

function markAvatarImage(event: Event, state: 'is-loaded' | 'is-failed'): void {
  const target = event.target;
  if (!(target instanceof HTMLImageElement)) return;
  if (!target.closest(AVATAR_CONTAINER_SELECTOR)) return;
  target.classList.add(state);
}
